<script setup lang="ts">
import { ref } from "vue";
import { onMounted } from "vue";
import { Dashboard } from "~/api";
import { apiClient } from "~/utils/apiClient";

const loading = ref(false);
const dashboardStatistics = ref<Dashboard>();

/**
 * Fetches statistics for the dashboard
 */

const getDashboardStatistics = async () => {
  loading.value = true;
  const temp = await apiClient.dashboard.getDashboardStatistics();
  dashboardStatistics.value = temp;
};

onMounted(async () => {
  await Promise.all([getDashboardStatistics()]);
});
</script>
<template>
  <div class="portal-dashboard">
    <div class="dashboard-section">
      <h3>Housed Applications</h3>
      <div class="statistic-section">
        <div class="statistic-card">
          <el-statistic :value="dashboardStatistics?.totalHoused">
            <template #title>
              <div style="display: inline-flex; align-items: center">Total</div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="dashboardStatistics?.housedCurrentMonth">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                This Month
              </div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="dashboardStatistics?.housedCurrentQuarter">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                This Quarter To-Date
              </div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="dashboardStatistics?.housedLastQuarter">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                Last Quarter
              </div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="dashboardStatistics?.housedCurrentYear">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                This Year To-Date
              </div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="dashboardStatistics?.housedLastYear">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                Last Year
              </div>
            </template>
          </el-statistic>
        </div>
      </div>
    </div>

    <div class="dashboard-section">
      <h3>New Applications</h3>
      <div class="statistic-section">
        <div class="statistic-card">
          <el-statistic :value="dashboardStatistics?.totalApplications">
            <template #title>
              <div style="display: inline-flex; align-items: center">Total</div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="dashboardStatistics?.newCurrentMonth">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                This Month
              </div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="dashboardStatistics?.newCurrentQuarter">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                This Quarter To-Date
              </div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="dashboardStatistics?.newLastQuarter">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                Last Quarter
              </div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="dashboardStatistics?.newCurrentYear">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                This Year To-Date
              </div>
            </template>
          </el-statistic>
        </div>
        <div class="statistic-card">
          <el-statistic :value="dashboardStatistics?.newLastYear">
            <template #title>
              <div style="display: inline-flex; align-items: center">
                Last Year
              </div>
            </template>
          </el-statistic>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less">
.portal-dashboard {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  gap: 2em;

  .dashboard-section {
    background-color: #f0f2f5;
    height: fit-content;
    padding: 0 0 10px 20px;
    border-radius: 10px;
  }

  .el-statistic {
    .el-statistic__head {
      font-size: 15px;
      font-weight: 400;
    }
  }

  .statistic-section {
    grid-area: "section";
    display: grid;
    grid-template-rows: repeat(2, 1fr);
    grid-template-columns: repeat(3, auto);
    grid-gap: 8px;
  }
  .statistic-card {
    padding: 15px;
  }
}
</style>
